import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './Login.css';

const Login: React.FC = () => {
  const [searchParams] = useSearchParams();
  const [isLogin, setIsLogin] = useState(!searchParams.get('register'));
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const { login, register } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (searchParams.get('register') === 'true') {
      setIsLogin(false);
    }
  }, [searchParams]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!email || !password) {
      setError('Имэйл болон нууц үгээ оруулна уу');
      return;
    }

    if (!isLogin && password !== confirmPassword) {
      setError('Нууц үг таарахгүй байна');
      return;
    }

    if (password.length < 6) {
      setError('Нууц үг дор хаяж 6 тэмдэгт байх ёстой');
      return;
    }

    setError('');
    setLoading(true);

    try {
      if (isLogin) {
        await login(email, password);
      } else {
        await register(email, password);
      }
      navigate('/');
    } catch (error: any) {
      console.error('Authentication error:', error);
      setError(getErrorMessage(error.code));
    } finally {
      setLoading(false);
    }
  };

  const getErrorMessage = (errorCode: string) => {
    switch (errorCode) {
      case 'auth/user-not-found':
        return 'Энэ имэйл бүртгэгдээгүй байна';
      case 'auth/wrong-password':
        return 'Нууц үг буруу байна';
      case 'auth/email-already-in-use':
        return 'Энэ имэйл аль хэдийн бүртгэгдсэн байна';
      case 'auth/weak-password':
        return 'Нууц үг хэтэрхий сул байна';
      case 'auth/invalid-email':
        return 'Имэйлийн хаяг буруу байна';
      default:
        return 'Алдаа гарлаа. Дахин оролдоно уу.';
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-header">
          <h1>🍔 Burger AI</h1>
          <h2>{isLogin ? 'Нэвтрэх' : 'Бүртгүүлэх'}</h2>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          {error && <div className="error-message">{error}</div>}
          
          <div className="form-group">
            <label className="form-label">Имэйл хаяг</label>
            <input
              type="email"
              className="form-control"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="your@email.com"
              required
            />
          </div>

          <div className="form-group">
            <label className="form-label">Нууц үг</label>
            <input
              type="password"
              className="form-control"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              required
            />
          </div>

          {!isLogin && (
            <div className="form-group">
              <label className="form-label">Нууц үг баталгаажуулах</label>
              <input
                type="password"
                className="form-control"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                placeholder="••••••••"
                required
              />
            </div>
          )}

          <button
            type="submit"
            className="btn btn-primary btn-large login-btn"
            disabled={loading}
          >
            {loading ? 'Түр хүлээнэ үү...' : (isLogin ? 'Нэвтрэх' : 'Бүртгүүлэх')}
          </button>
        </form>

        <div className="login-footer">
          <p>
            {isLogin ? 'Шинэ хэрэглэгч үү?' : 'Аль хэдийн бүртгүүлсэн үү?'}
            <button
              type="button"
              className="link-button"
              onClick={() => {
                setIsLogin(!isLogin);
                setError('');
                setEmail('');
                setPassword('');
                setConfirmPassword('');
              }}
            >
              {isLogin ? 'Бүртгүүлэх' : 'Нэвтрэх'}
            </button>
          </p>
        </div>

        <div className="demo-accounts">
          <h3>🎯 Demo режим - Ямар ч имэйл ашиглаж болно!</h3>
          <div className="demo-account">
            <strong>Админ эрх:</strong> admin@gmail.com / 123456
          </div>
          <div className="demo-account">
            <strong>Энгийн хэрэглэгч:</strong> user@gmail.com / 123456
          </div>
          <div className="demo-account">
            <strong>Ямар ч имэйл:</strong> myname@email.com / password
          </div>
          <div className="demo-note">
            <small>
              💡 Ямар ч имэйл хаяг, ямар ч нууц үг ашиглаж болно!<br/>
              "admin" үг агуулсан имэйл нь админ эрх авна.
            </small>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
